var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon-wrapper"},[_c('svg',{style:({
      width: _vm.size + 'rem',
      height: _vm.size + 'rem',
    }),attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":`#${_vm.icon}`}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }